import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, Grid, List, ListItem, ListItemText, Paper, TextField, Typography } from '@mui/material';
import configSiteUrls from '../../../configs/configSiteUrls';

import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { format } from 'date-fns';
import DownloadAnexoButton from '../../noticia/create/DownloadAnexoButton';
import { CentroApoioList, IScentroApoioList } from '../types/CentroApoio';
import { CentroApoioAnexo } from '../types/CentroApoioAnexo';

interface Props {
  dados: CentroApoioList;
  centroApoioAnexoSalvo: CentroApoioAnexo[] | null;

  
  isLoadingAnexo: boolean;
}

export const CentroApoioPainelDadoAtual = ({ dados, centroApoioAnexoSalvo, isLoadingAnexo }: Props) => {
  return (
    <>
      {dados.id && (
        <>
          <Card>
            <Accordion defaultExpanded={false}>
              <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                <Typography color="secondary" sx={{ mb: 3, fontWeight: 'bold' }} variant="body1" gutterBottom>
                  Dados da Solicitação
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Nome
                      </Typography>
                      <Typography variant="body1" fontWeight="500">
                        {dados.nome || 'Não informado'}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Documento
                      </Typography>
                      <Typography variant="body1" fontWeight="500">
                        {dados.documento || 'Não informado'}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        E-mail
                      </Typography>
                      <Typography variant="body1" fontWeight="500">
                        {dados.email || 'Não informado'}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Telefone
                      </Typography>
                      <Typography variant="body1" fontWeight="500">
                        {dados.telefone || 'Não informado'}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Categoria
                      </Typography>
                      <Typography variant="body1" fontWeight="500">
                        {dados.categoria || 'Não informado'}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Observação
                      </Typography>
                      <Typography variant="body1" fontWeight="500" sx={{ whiteSpace: 'pre-line' }}>
                        {dados.observacao || 'Não informado'}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>

                {centroApoioAnexoSalvo && centroApoioAnexoSalvo.length > 0 && (
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Box>
                        <Accordion defaultExpanded={false}>
                          <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel2-content" id="panel4-header">
                            <Typography color="secondary" variant="body1" gutterBottom>
                              Anexos
                            </Typography>
                          </AccordionSummary>

                          <AccordionDetails>
                            <Paper>
                              {!isLoadingAnexo && (
                                <List dense>
                                  {centroApoioAnexoSalvo.map((file: CentroApoioAnexo) => (
                                    <ListItem key={file.path} disablePadding secondaryAction={<DownloadAnexoButton tipo="CENTRO_APOIO" ida={file.path} fileName={file.nomeOriginal} />}>
                                      <ListItemText
                                        primary={file.nomeOriginal}
                                        primaryTypographyProps={{
                                          variant: 'body2',
                                          color: 'secondary'
                                        }}
                                      />
                                    </ListItem>
                                  ))}
                                </List>
                              )}
                            </Paper>
                          </AccordionDetails>
                        </Accordion>
                      </Box>
                    </Grid>
                  </Grid>
                )}
              </AccordionDetails>
            </Accordion>
          </Card>
        </>
      )}
    </>
  );
};
